import { useCallback, useEffect, useState } from "react";
import MenuTop from "../../../components/menu/top/menu-top";
import storage from "../../../shared/services/storage";
import Form from "../../../components/form/form";
import financialFormData from "../../../features/financial/forms/financial-form-data";
import { fetchTiposLancamento } from "../../../features/lancamento/service/tipo-lancamento";
import InfoComponent from "../../../components/info/info";
import { FormProps } from "../../../shared/interfaces/form";
import { fetchRubricasGrouped } from "../../../features/rubrica/service/rubrica";
import { User } from "../../../shared/interfaces/user";
import { fetchFinancialsByProjectIdService, setFinancialData } from "../../../features/financial/service/financeiro-service";
import { SEVERITY } from "../../../shared/interfaces/alert";
import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../../components/alert/alert";
import './style.css';
import { fetchBeneficiariesByIdCompanyService, fetchBeneficiariesService, fetchBeneficiaryService } from "../../../features/beneficiary/service/beneficiary-service";
import formatDateToISO from "../../../shared/utils/data-formatter";
import { toCents } from "../../../shared/utils/money";

function Financial() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const [formData, setFormData] = useState<FormProps[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const getTiposLancamento = useCallback(async () => {
        try {
            const lancamentos = await fetchTiposLancamento();
            return lancamentos?.map(({ name, id}: any) => ({ label: name, value: id }));
        } catch (error) {
            console.error(error);
        }
    }, []);


    const getRubricasGrouped = useCallback(async () => {
        try {
            return await fetchRubricasGrouped();;
        } catch (error) {
            console.error(error);
        }
    }, []);

    const getProjectsByFinancier = useCallback(async () => {
        const userData: User =  await JSON.parse(storage.getStorage('user') || '');

        try {
            const projects = await fetchFinancialsByProjectIdService(userData.company.id as string);
            return projects?.map(({ name, id}: any) => ({ label: name, value: id }));
        } catch (error) {
            console.error(error);
        }
    }, []);

    const getBeneficiaries = useCallback(async () => {
        const userData: User =  await JSON.parse(storage.getStorage('user') || '');
        try {
            if (userData.company?.name?.toLowerCase() === 'causale') {
                return await fetchBeneficiariesService();
            }

            return await fetchBeneficiariesByIdCompanyService(userData.company.id as string);
        } catch (error) {
            console.error(error);
        }
    }, []);

    const setFormValues = useCallback( async () => {
        setIsLoading(true);
        try {
            const response = { idProject: id }
            const shouldShowProjectSelect = id ? false : true;

            const [valueLancamentos, valueRubricasGrouped, valueProjects, valueBeneficiaries] = await Promise.all([
                getTiposLancamento(),
                getRubricasGrouped(),
                getProjectsByFinancier(),
                getBeneficiaries()
            ]);

            setFormData(financialFormData(undefined, response, valueLancamentos, valueRubricasGrouped, valueProjects, valueBeneficiaries, shouldShowProjectSelect));
        } catch (error) {
            console.error("Erro ao carregar dados do formulário:", error);
            showAlert('Erro ao carregar dados do formulário', SEVERITY.ERROR);
        } finally {
            setIsLoading(false);
        }
    }, [getTiposLancamento, getRubricasGrouped, getProjectsByFinancier, getBeneficiaries, id, showAlert]);

    useEffect(() => {
        setFormValues();
    }, [setFormValues]);

    const onSubmitForm = async (data: any) => {
        setIsLoading(true);

        try {
            const updatedData = {
                ...data,
                idProject: id ? id : data.idProject,
                valor: toCents(data.valor)
            };

            const financialDataAddedFormatted = formatDateToISO(data.financialDateAdded);
            updatedData.financialDateAdded = financialDataAddedFormatted;

            await setFinancialData(updatedData, null);
            showAlert('Dados financeiros salvos com sucesso', SEVERITY.SUCCESS);
            navigate(`/projeto/${id}`, { replace: true });
            
        } catch (error: any) {
            setIsLoading(false);
            showAlert(
                error.message || 'Erro ao salvar dados financeiros', 
                SEVERITY.ERROR
            );
        } finally { 
            setIsLoading(false);
        }
    }

    return (
        <div className="container-add-financial">
            <MenuTop />
            <InfoComponent />
            <div className="container-add-financial__container">
                <Form
                    data={formData}
                    title="Cadastrar nova movimentação financeira"
                    onSubmitForm={onSubmitForm}
                    onCancel={() => navigate(`/projeto-list/${id}`, { replace: true })}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
}

export default Financial;
